import * as actions from './actions';

const initialState = {
    user: null,
    addresses: [],
    sessionId: null,
    isInitialized: false,
    isAddressesInitialized: false,
    isAuthenticated: false,
    errorAuth: null,
    successAuth: false,
    loadingAuth: false,

};



export function reducerAuth(state = initialState, { type, ...action }) {
    switch (type) {
        // access
        case actions.SET_USER.SUCCESS:
            return {
                ...state,
                user: action.user,
                isInitialized: true,
                isAuthenticated: true,
                errorAuth: null,
                loadingAuth: false,
            };

        case actions.INITIALIZE.SUCCESS:
            return {
                ...state,
                isInitialized: true,
                sessionId: action.sessionId
            };

        case actions.RESET_SESSION_ID.SUCCESS:
            return {
                ...state,
                sessionId: action.sessionId
            };



        case actions.LOGOUT.SUCCESS:
            return {
                ...state,
                user: null,
                isInitialized: true,
                isAuthenticated: false,
            };

        // addresses

        case actions.SET_USER_ADDRESS.REQUEST:
            return { ...state, loading: true, error: null };

        case actions.SET_USER_ADDRESS.SUCCESS:
            return { ...state, loading: false, addresses: action.payload.addresses };

        case actions.SET_USER_ADDRESS.FAILURE:
            return { ...state, loading: false, error: action.payload.error };
        
        case actions.DELETE_USER_ADDRESS.SUCCESS:
            return { ...state, addresses: action.payload.addresses };


        // update tour 
        case actions.UPDATE_TOUR.SUCCESS: {
            state.user.user_on_guided_tour = action.tour;

            return { ...state }
        }

        case actions.UPDATE_TOUR.FAILURE:
            return { ...state, errorAuth: action.message }

        // ----------------------------------------------------------------------

        case actions.FETCH_SPOREUSER.SUCCESS:
            return {
                ...state,
                user: action.payload.sporeuser,
                isInitialized: true,
                isAuthenticated: true,
                errorAuth: null,
                loadingAuth: false,
            };


        // ----------------------------------------------------------------------

        case actions.FETCH_ADDRESSES.SUCCESS:
            return {
                ...state,
                addresses: action.payload.addresses,
                isAddressesInitialized: true,

                errorAuth: null,
                loadingAuth: false,
            };


        case actions.FETCH_SPOREUSER_PERKS.SUCCESS:

            if (state.user) {
                return {
                    ...state,
                    user: {
                        ...state.user,
                        perks_on_user: action.payload.perks, // Set the new value for perks_on_user
                    },

                    isInitialized: true,
                    isAuthenticated: true,
                    errorAuth: null,
                    loadingAuth: false,
                };
            }


            return {
                ...state,
            };





        // ----------------------------------------------------------------------
        case actions.UPDATE_SPOREUSER.REQUEST:
            return { ...state, loadingAuth: true, successAuth: false, errorAuth: null };

        case actions.UPDATE_SPOREUSER.SUCCESS: {
            return { ...state, loadingAuth: false, successAuth: 'Perfil guardado', initial: true, user: action.payload.sporeuser };
        }

        case actions.UPDATE_SPOREUSER.FAILURE:
            return { ...state, loadingAuth: false, initial: false, successAuth: false, errorAuth: action.payload.error };

        // ----------------------------------------------------------------------

        case actions.ADD_SPOREUSER_IMAGE.REQUEST:
            return { ...state, loadingAuth: true, successAuth: false, errorAuth: null };

        case actions.ADD_SPOREUSER_IMAGE.SUCCESS: {
            return { ...state, loadingAuth: false, successAuth: 'Imagen agregada', initial: true, user: action.payload.sporeuser };
        }

        case actions.ADD_SPOREUSER_IMAGE.FAILURE:
            return { ...state, loadingAuth: false, errorAuth: action.payload.errorAuth };



        // ----------------------------------------------------------------------

        case actions.UPDATE_SPOREUSER_SOCIAL.REQUEST:
            return { ...state, loadingAuth: true, successAuth: false, errorAuth: null };

        case actions.UPDATE_SPOREUSER_SOCIAL.SUCCESS: {
            return { ...state, loadingAuth: false, successAuth: 'Cambios guardados', errorAuth: null, user: { ...state.user, social_on_sporeuser: action.payload.social } };
        }

        case actions.UPDATE_SPOREUSER_SOCIAL.FAILURE:
            return { ...state, loadingAuth: false, successAuth: false, errorAuth: action.payload.error };

        // ----------------------------------------------------------------------

        case actions.REMOVE_SPOREUSER_IMAGE.REQUEST:
            return { ...state, loadingAuth: true, successAuth: false, errorAuth: null };

        case actions.REMOVE_SPOREUSER_IMAGE.SUCCESS: {
            return { ...state, loadingAuth: false, successAuth: 'Imagen eliminada', initial: true, user: action.payload.sporeuser };
        }

        case actions.REMOVE_SPOREUSER_IMAGE.FAILURE:
            return { ...state, loadingAuth: false, successAuth: false, errorAuth: action.payload.error };

        // ----------------------------------------------------------------------


        case actions.ADD_SPOREUSER_SPECIALTY.REQUEST:
            return { ...state, loadingAuth: true, successAuth: false, errorAuth: null };

        case actions.ADD_SPOREUSER_SPECIALTY.SUCCESS:
            return { ...state, loadingAuth: false, successAuth: 'Especialidad agregada', errorAuth: null };

        case actions.ADD_SPOREUSER_SPECIALTY.FAILURE:
            return { ...state, loadingAuth: false, successAuth: false, errorAuth: action.payload.error };


        // ----------------------------------------------------------------------

        case actions.REMOVE_SPOREUSER_SPECIALTY.REQUEST:
            return { ...state, loadingAuth: true, successAuth: false, errorAuth: null };

        case actions.REMOVE_SPOREUSER_SPECIALTY.SUCCESS:
            return { ...state, loadingAuth: false, successAuth: 'Especialidad removida', errorAuth: null };

        case actions.REMOVE_SPOREUSER_SPECIALTY.FAILURE:
            return { ...state, loadingAuth: false, successAuth: false, errorAuth: action.payload.error };

        // ----------------------------------------------------------------------


        case actions.ADD_SPOREUSER_SUBSPECIALTY.REQUEST:
            return { ...state, loadingAuth: true, successAuth: false, errorAuth: null };

        case actions.ADD_SPOREUSER_SUBSPECIALTY.SUCCESS:
            return { ...state, loadingAuth: false, successAuth: 'SubEspecialidad agregada', errorAuth: null };

        case actions.ADD_SPOREUSER_SUBSPECIALTY.FAILURE:
            return { ...state, loadingAuth: false, successAuth: false, errorAuth: action.payload.error };


        // ----------------------------------------------------------------------

        case actions.REMOVE_SPOREUSER_SUBSPECIALTY.REQUEST:
            return { ...state, loadingAuth: true, successAuth: false, errorAuth: null };

        case actions.REMOVE_SPOREUSER_SUBSPECIALTY.SUCCESS:
            return { ...state, loadingAuth: false, successAuth: 'SubEspecialidad removida', errorAuth: null };

        case actions.REMOVE_SPOREUSER_SUBSPECIALTY.FAILURE:
            return { ...state, loadingAuth: false, successAuth: false, errorAuth: action.payload.error };

        // ----------------------------------------------------------------------

        case actions.UPDATE_SPOREUSER_PASSWORD.REQUEST:
            return { ...state, loadingAuth: true, successAuth: false, errorAuth: null };

        case actions.UPDATE_SPOREUSER_PASSWORD.SUCCESS: {
            return { ...state, loadingAuth: false, successAuth: 'Contraseña actualizada', errorAuth: null };
        }

        case actions.UPDATE_SPOREUSER_PASSWORD.FAILURE:
            return { ...state, loadingAuth: false, successAuth: false, errorAuth: action.payload.error };

        // ----------------------------------------------------------------------
        case actions.CLEAR_SPOREUSER_STATUS.SUCCESS:
            return { ...state, loadingAuth: false, successAuth: false, errorAuth: null };

        // ----------------------------------------------------------------------


        default:
            return state;
    }
}